import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from "react";
import { FormattedMessage } from "react-intl";
import { gql } from "@apollo/client";
import Price from "@overrides_venia/venia-ui/components/Price";
import { mergeClasses } from "@magento/venia-ui/lib/classify";

/**
 * A component that renders the discount summary line item.
 *
 * @param {Object} props.classes
 * @param {Object} props.data fragment response data
 */
var DiscountSummary = props => {
  var _discounts$amount;
  var classes = mergeClasses({}, props.classes);
  var discounts = props.data;
  var discountAmountValue = discounts && discounts !== null && discounts !== void 0 && discounts.amount && (_discounts$amount = discounts.amount) !== null && _discounts$amount !== void 0 && _discounts$amount.value ? discounts.amount.value : 0;
  var currencyCode = discountAmountValue ? discounts.amount.currency : "EUR";
  return discountAmountValue ? /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-middle subtotal-summary ".concat(classes.discountSummary)
  }, /*#__PURE__*/React.createElement("span", {
    className: "uk-text-uppercase uk-margin-auto-right subtotal-summary-text ".concat(classes.text)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reduced.label"
  })), /*#__PURE__*/React.createElement("span", {
    className: "uk-margin-auto-left subtotal-summary-price weglotExclude"
  }, /*#__PURE__*/React.createElement(Price, {
    value: discountAmountValue,
    currencyCode: currencyCode,
    doublePrecision: true
  }))) : null;
};
export var DiscountSummaryFragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment DiscountSummaryFragment on CartPrices {\n        discount {\n            amount {\n                currency\n                value\n            }\n        }\n        discounts {\n            amount {\n                currency\n                value\n            }\n        }\n    }\n"])));
export default DiscountSummary;